import BaseApi from './baseApi';

export default class OrganizationsApi extends BaseApi {
  static getAll = () => {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    return this.axiosInstance.get(`${this.API}/organization/all`, config);
  };

  static create = (organization) => {
    const config = {
      method: 'post',
      headers: this.getAuthHeaders(),
    };

    return this.axiosInstance.post(
      `${this.API}/organization`,
      JSON.stringify(organization),
      config,
    );
  };

  static update = (organization) => {
    const config = {
      method: 'put',
      headers: this.getAuthHeaders(),
    };

    return this.axiosInstance.put(
      `${this.API}/organization/${organization.id}`,
      JSON.stringify(organization),
      config,
    );
  };

  static delete = (organizationId) => {
    const config = {
      method: 'delete',
      headers: this.getAuthHeaders(),
    };
    return this.axiosInstance.delete(`${this.API}/organization/${organizationId}`, config);
  };
}
